import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=61c69dc0&scoped=true&"
import script from "./ActiveFilters.vue?vue&type=script&lang=js&"
export * from "./ActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&id=61c69dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c69dc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VLayout,VSpacer})
